<template>
  <div class="app flex-row align-items-center">
    <div class="container">
      <b-row class="justify-content-center">
        <b-col md="6">
          <b-card-group>
            <b-card no-body class="p-12 transparent-bg login-form">
              <b-card-body id="login-form">
                <b-form>
                  <b-input-group class="mb-3">
                    <b-input-group-prepend><b-input-group-text><i class="icon-user"></i></b-input-group-text></b-input-group-prepend>
                    <b-form-input type="email" 
                                  class="form-control" 
                                  placeholder="帳號(通常是email)"
                                  v-model.lazy.trim="$v.username.$model"
                                  v-focus
                                  :state="chkState('username')"
                                  aria-describedby="invalidEmailFeedback"
                                  @keyup.enter="submit"/>
                    <b-form-invalid-feedback id="invalidEmailFeedback">請填入有效的帳號</b-form-invalid-feedback>
                  </b-input-group>
                  <b-input-group class="mb-4">
                    <b-input-group-prepend><b-input-group-text><i class="icon-lock"></i></b-input-group-text></b-input-group-prepend>
                    <b-form-input type="password" 
                                  class="form-control" 
                                  placeholder="密碼"
                                  v-model.lazy.trim="$v.password.$model"
                                  :state="chkState('password')"
                                  aria-describedby="invalidPasswordFeedback"
                                  @keyup.enter="submit"/>
                    <b-form-invalid-feedback id="invalidPasswordFeedback">密碼最少5個字母</b-form-invalid-feedback>
                  </b-input-group>
                  <b-row>
                    <b-col cols="12">
                      <b-button variant="primary" class="w-100 px-4" @click="submit()">登入</b-button>
                    </b-col>
                    <br/>
                  </b-row>

                  <b-row>
                    <b-col>
                      <div class="mt-1 ml-auto text-white pri-info-declaration text-center">
                        <span v-html="PrivacyPolicy"></span> 
                      </div>
                    </b-col>
                  </b-row>

                  <b-row>
                    <b-col>
                      <div class="ml-auto text-white pri-info-declaration text-center">
                        {{$t('innoknight') + '©' + thisyear}}
                      </div>
                    </b-col>
                  </b-row>

                </b-form>
              </b-card-body>
            </b-card>
          </b-card-group>
        </b-col>
      </b-row>
    </div>
  </div>
</template>

<script>
import { required, minLength, between, email } from 'vuelidate/lib/validators'
import VueNotifications from 'vue-notifications'
import config from '@/config/global'
import notifications from '@/config/notifications'

const encrypt  = config.encrypt;
const decrypt  = config.decrypt;
const api_root = config.api_root;

const get_access_token = function (username, secret) {

  let action = `${api_root}/get_token`;
  let params = {
    keyset: 'mqtt',
    access: encodeURIComponent(encrypt(JSON.stringify({username, secret}))),
    bring_navs: true
  };

  return this.$jsonp(action, params);//return the Promise

};//eo get_access_token

let getUrlParameter = function getUrlParameter(url) {
    var sPageURL = url.substring(url.indexOf('?')+1),
        sURLVariables = sPageURL.split('&'),
        sParameterName,
        i,
        rlt={};


    for (i = 0; i < sURLVariables.length; i++) {
        sParameterName = sURLVariables[i].split('=');
        rlt[sParameterName[0]] = sParameterName[1];
    }

    return rlt;
};//eo getUrlParameter

export default {
  name: 'Login',
  
  notifications,

  beforeMount() {
    let pre_error = this.$state.$get('error');
    let app       = this;

    if(pre_error === config.error.INVALID_USER){
      this.showError({message:'請先登入', title:'使用者尚未通過驗證'});
      this.$state.$del('error');
      return false;
    }

    if(location.hash){
      let get_params = getUrlParameter(location.hash);

      if(!get_params.ccid){
        return;
      }

      let params = {
        ccid: get_params.ccid
      };

      this.$state.$set('ccid', decodeURIComponent(get_params.ccid));

      if(get_params && get_params.ccid){
        this.$jsonp(`${config.admin_root}/get_company`, params).then((result) => {
          // console.info('company: ', company);
          if(result && result.company && result.company.name){
            app.prefix = result.company.name;

            this.$state.$set('company_name', result.company.name);
          }
        });
      }
    }

  },//eo beforeMount

  mounted(){
    // console.info('okay: ', this.$state.$get('user'));
    if(config.styles && config.styles){
      // console.info('config.styles:', config.styles);
      jQuery('.app').css(config.styles);
    }

    if(config.overwritetitle){
      // console.info('config.overwritetitle:', config.overwritetitle);
      document.title = config.overwritetitle;
    }
  },//eo mounted

  data() {
    const this_year = new Date();

    return {
      username: '',
      password: '',
      prefix:   '',
      thisyear: this_year.getFullYear(),
      footer: config.footer,
    };
  },//eo data

  computed: {
    PrivacyPolicy() {
      const link = `<a href="https://law.moj.gov.tw/LawClass/LawAll.aspx?PCode=I0050021" target="_blank">${this.$t('personal_data_protection_act')}</a>`;
      return this.$t('privacy_policy_message', { link });
    }
  },//eo computed

  methods: {
    submit(){
      // console.info('submit');
      let app = this;

      this.$v.$touch();

      if (this.$v.$invalid) {
        this.showError({message:'請輸入您的帳號密碼', title:'登入訊息錯誤'});
        return false;
      }

      let get_token = get_access_token.apply(this,[this.username, this.password]);
      get_token.then((user_token) => {
        
        if(!user_token.success){
          app.showWarn({
            message:user_token.message, 
            title:'服務端錯誤'
          });
          return false;
        } else {
          
          app.showSuccess({
            message: '歡迎使用',
            title: '登入成功'
          });

          this.$state.$set('adminuser', user_token);

          let ccid = this.$state.$get('ccid');

          // console.info('ccid:', ccid);

          if (user_token.ccid) {
            ccid = `${user_token.ccid}`;
          }

          if(ccid && !user_token.sii){
            this.$state.$set('ccff', ccid);
          } else {
            this.$state.$set('ccff', 'N/A');
          }

          if(user_token.after_login_page){
            this.$router.push(user_token.after_login_page);
          } else {
            this.$router.push('/dashboard/home');
          }
        }


      }).catch((error) => {
        console.info('user_token error:', error);
      });
    },
    chkState(val) {
      const field = this.$v[val];
      return !field.$dirty || !field.$invalid;
    },
  },//eo methods

  validations: {
    username: {
      //email,
      required,
      minLength: minLength(4)
    },
    password: {
      required,
      minLength: minLength(5),
    }
  }//eo validations
}
</script>

<style>
.card-body{
  padding: 1.25rem !important;
}
</style>
  